/* eslint-disable @typescript-eslint/no-unused-vars */
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch } from "./useAppDispatch";
import { onDIPtrigger, selectDipState } from "redux/slices";
import { useAppSelector } from "./useAppSelector";
import { setIsChecking } from "redux/slices/in-app-to-web-dip";
import { request } from "http";

enum DipParams {
	WebDipTrigger = "webDipTrigger",
	AppDipId = "appDipId",
	RequestId = "requestId"
}

//const LS_SURVIVABLE_DIP_LINK = "store.solitairetripeaks.com:survivableDipLink";
export const useInAppDipToWebDip = () => {
	const [searchParams] = useSearchParams();
	const dispatch = useAppDispatch();
	const { data: dipsData } = useAppSelector(selectDipState);
	const isAppDipToWebDip =
		searchParams.has(DipParams.WebDipTrigger) &&
		searchParams.has(DipParams.AppDipId);
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const { authToken, openLoginToContinueDialog } = useWebStoreContext();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const isAutoLogin = searchParams.has("loginType");

	useEffect(() => {
		if (isAppDipToWebDip) {
			if (isAutoLogin) {
				return;
			}
			dispatch(setIsChecking(true));
			const webDipTrigger = searchParams.get(DipParams.WebDipTrigger);
			const appDipId = searchParams.get(DipParams.AppDipId) || undefined;
			const requestId = searchParams.get(DipParams.RequestId) || undefined;

			if (!authToken?.value) {
				openLoginToContinueDialog();
				dispatch(setIsChecking(false));
				return;
			}
			if (webDipTrigger && dipsData?.dips) {
				const webDipFound = dipsData?.dips?.find(
					(dip) => dip?.dip?.triggerType === webDipTrigger
				);

				reportEvent("in_app_to_web_dip", {
					source: "in_app_to_web_dip",
					trigger_type: webDipTrigger,
					app_dip_id: appDipId,
					web_dip_found: !!webDipFound,
					campaign_id: webDipFound?.dip?.campaignGroup,
					request_id: requestId
				});
				reportPlaygamiEvent("tp.web_frontend", {
					event_name: "in_app_to_web_dip",
					event_type: "in_app_DIP_to_web_DIP",
					action: "in_app_to_web_dip",
					source: appDipId,
					offer_id: webDipFound?.dip?.id,
					type: webDipTrigger,
					tag_type: !!webDipFound,
					campaign_id: webDipFound?.dip?.campaignGroup,
					request_id: requestId
				});

				dispatch(
					onDIPtrigger({ triggerType: webDipTrigger, appDipId, requestId })
				);

				searchParams.delete(DipParams.AppDipId);
				searchParams.delete(DipParams.WebDipTrigger);

				navigate(
					{
						pathname,
						search: searchParams.toString()
					},
					{ replace: true }
				);
			}
			dispatch(setIsChecking(false));
		} else {
			//if user is logged in and requestId is present in url, remove it
			if (
				authToken?.value &&
				!isAutoLogin &&
				searchParams.has(DipParams.RequestId)
			) {
				searchParams.delete(DipParams.RequestId);
				navigate(
					{
						pathname,
						search: searchParams.toString()
					},
					{ replace: true }
				);
			}
			dispatch(setIsChecking(false));
		}
	}, [authToken?.value, isAppDipToWebDip, isAutoLogin, dipsData?.dips]);
};
